import { render } from "./FunctionHelp.vue?vue&type=template&id=d9bd0d26&scoped=true&ts=true"
import script from "./FunctionHelp.vue?vue&type=script&lang=ts"
export * from "./FunctionHelp.vue?vue&type=script&lang=ts"

import "./FunctionHelp.vue?vue&type=style&index=0&id=d9bd0d26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9bd0d26"]])

export default __exports__